import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-5a06895a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "landingWrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landingText" }, " Carte Confituur is een grafische ontwerpstudio & one-woman-business uit Nazareth-De Pinte die jouw bedrijfsverhaal creatief vertaalt en jullie geboorte- of huwelijksgeluk graag extra in de verf helpt zetten. ", -1))
const _hoisted_4 = { class: "callToActionDiv" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("IK WIL SAMENWERKEN")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "arrow"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "calltoaction",
          to: "/contact"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _hoisted_6
    ])
  ]))
}